// SECOND wokring JS

document.addEventListener('DOMContentLoaded', function () {

  const megaMenus = document.querySelectorAll('.custom-mega-menu');
  if (!megaMenus.length) return;

  const headerNav = document.querySelector('.bdb-header__nav');
  if (!headerNav) return;

  const subTitleEl = document.getElementById('mega-sub-title');
  const prodTitleEl = document.getElementById('mega-products-title');

  const toHandle = (text) =>
    text.toLowerCase().trim().replace(/\s+/g, '-');

  const hideAllMegaMenus = () => {
    megaMenus.forEach(menu => menu.classList.remove('is-active'));
  };

  const isDesktop = () =>
    window.matchMedia('(min-width: 990px)').matches;

  // ================= Header Menu Hover =================
  headerNav.querySelectorAll('.bdb-header__nav-link').forEach(link => {

    const label = link.querySelector('.bdb-header__nav-label');
    if (!label) return;

    const handle = toHandle(label.textContent);
    const relatedMegaMenu = document.querySelector(
      `.custom-mega-menu[data-menu="${handle}"]`
    );

    if (!relatedMegaMenu) return;

    link.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      hideAllMegaMenus();
      relatedMegaMenu.classList.add('is-active');
    });
  });

  // new code to fix hover nav item issue
  // CLOSE mega menu when hovering another nav item
headerNav.querySelectorAll('.bdb-header__nav-item').forEach(item => {

  item.addEventListener('mouseenter', () => {

    const link = item.querySelector('.bdb-header__nav-link');
    if (!link) return;

    const label = link.querySelector('.bdb-header__nav-label');
    if (!label) {
      hideAllMegaMenus();
      return;
    }

    const handle = toHandle(label.textContent);
    const relatedMegaMenu = document.querySelector(
      `.custom-mega-menu[data-menu="${handle}"]`
    );

    // If this nav item has NO mega menu → close all
    if (!relatedMegaMenu) {
      hideAllMegaMenus();
    }

  });

});




  megaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      menu.classList.add('is-active');
    });

    menu.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      menu.classList.remove('is-active');
    });
  });

  // ================= Column 1 → Column 2 → Column 3 =================
  document.querySelectorAll('.mega-main-item').forEach(mainItem => {

    // HOVER
    mainItem.addEventListener('mouseenter', () => {
      const handle = mainItem.dataset.handle;
      if (!handle) return;

      document.querySelectorAll('.mega-main-item')
        .forEach(i => i.classList.remove('active'));
      mainItem.classList.add('active');

      document.querySelectorAll('.mega-sub-collections')
        .forEach(ul => ul.classList.remove('active'));

      const relatedSub = document.querySelector(
        `.mega-sub-collections[data-parent="${handle}"]`
      );

      if (!relatedSub) return;
      relatedSub.classList.add('active');

      if (subTitleEl) subTitleEl.textContent = mainItem.textContent;

      const firstSub = relatedSub.querySelector('.mega-sub-item');
      if (!firstSub) return;

      activateSubItem(firstSub);
    });

    // CLICK → navigate
    mainItem.addEventListener('click', () => {
      const url = mainItem.dataset.url;
      if (url) window.location.href = url;
    });
  });

  // ================= Column 2 → Column 3 =================
  document.querySelectorAll('.mega-sub-item').forEach(subItem => {

    // HOVER
    subItem.addEventListener('mouseenter', () => {
      activateSubItem(subItem);
    });

    // CLICK → navigate
    subItem.addEventListener('click', () => {
      const url = subItem.dataset.url;
      if (url) window.location.href = url;
    });
  });

  // ================= Helper =================
  function activateSubItem(subItem) {
    const handle = subItem.dataset.subHandle;
    if (!handle) return;

    document.querySelectorAll('.mega-sub-item')
      .forEach(i => i.classList.remove('active'));
    subItem.classList.add('active');

    document.querySelectorAll('.mega-products')
      .forEach(p => p.classList.remove('active'));

    const relatedProducts = document.querySelector(
      `.mega-products[data-products="${handle}"]`
    );

    if (relatedProducts) relatedProducts.classList.add('active');
    if (prodTitleEl) prodTitleEl.textContent = subItem.textContent;
  }

  // ================= Default Load =================
  const firstActiveSubList = document.querySelector('.mega-sub-collections.active');
  if (firstActiveSubList) {
    const firstSub = firstActiveSubList.querySelector('.mega-sub-item');
    if (firstSub) activateSubItem(firstSub);
  }

// // hide megamenu if not on hader
//   document.querySelector('.bdb-header').addEventListener('mouseleave', () => {
//     hideAllMegaMenus();
//   });
});
